import legalTabs from './parts/legal-tabs'

document.addEventListener('DOMContentLoaded', () => {
  new legalTabs()
})